export const user = [
  '32 32',
  `
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="2.24" stroke="#000" d="M2.963 30.667v-3.259c0-1.729 0.687-3.387 1.909-4.609s2.881-1.909 4.609-1.909h13.037c1.729 0 3.387 0.687 4.609 1.909s1.909 2.881 1.909 4.609v3.259"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="2.24" stroke="#000" d="M16 14.37c-3.6 0-6.518-2.918-6.518-6.519s2.918-6.519 6.518-6.519c3.6 0 6.519 2.918 6.519 6.519s-2.918 6.519-6.519 6.519z"></path>
`,
]
